import React from "react";

import Portal from "../Portal";

import styles from "./SideModal.module.scss";

type Props = {
  parentPositionTop: string;
  parentPositionLeft: string;
  onClose: () => void;
  children: React.ReactNode;
};

const SideModal = ({
  parentPositionTop,
  parentPositionLeft,
  onClose,
  children,
}: Props) => {
  return (
    <Portal>
      <div className={styles.modal}>
        <div className={styles.modal__backDrop} onClick={onClose} />
        <div
          className={styles.modal__content}
          style={{ top: parentPositionTop, left: parentPositionLeft }}
        >
          {children}
        </div>
      </div>
    </Portal>
  );
};

export default SideModal;
